import React from "react";
import "./ProductBannerMobile.css";
import ButtonCotizarMobile from "./ButtonCotizarMobile";
import {Link} from "react-router-dom";

const ProductBannerMobile = (props) => {
    const productName = props.productName;
    const productIcon = props.productIcon;
    let componentToShow;

    switch (productName) {
        case "AUTO":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/vehiculo`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <ButtonCotizarMobile/>
                </Link>
            );
            break;
        case "MOTO":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/motovehiculo`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <ButtonCotizarMobile/>
                </Link>
            );
            break;
        case "HOGAR":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/combinado`,
                        state: {datosUser: props.datosUser}
                    }}
                >
                    <ButtonCotizarMobile/>
                </Link>
            );
            break;
        case "MICROSEGUROS":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/microseguro`,
                        state: {datosUser: props.datosUser}
                    }}
                >
                    <ButtonCotizarMobile/>
                </Link>
            );
            break;
        case "OTROS SEGUROS":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/otros`,
                        state: {datosUser: props.datosUser}
                    }}
                >
                    <ButtonCotizarMobile/>
                </Link>
            );
            break;
    }

    return (
        <React.Fragment>
            <div
                className="box-mobile"
                style={{
                    display: "flex",
                    flexDirection: "row",
                }}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column", justifyContent: "center", alignContent: "center", width: "30%",
                }}>
                    <img
                        className="img-icon-mobile"
                        style={{
                            width: "128px",
                            height: "auto",
                        }}
                        src={productIcon}
                        alt="microseg_icon"
                    />
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "column", justifyContent: "center", alignContent: "center", width: "70%",
                }}>
                    <p
                        className="font-face-encode-sans-extra-bold product-name-mobile"
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            textAlign: "center",
                        }}
                    >
                        {productName}
                    </p>
                    <div style={{
                        display: "flex",
                        flexDirection: "row", justifyContent: "center", marginTop: "5px"
                    }}>{componentToShow}</div>

                </div>

            </div>
        </React.Fragment>
    );
};

export default ProductBannerMobile;
